import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { store } from '@/store';
import { createAppTheme } from '@/styles/theme';
import { useTheme, useAppInit } from '@/hooks';
import { GlobalLoader, AppRoutes } from '@/components';
import { COLORS } from '@/constants/colors';

const AppRoutesWithTracking: React.FC = () => {
  // Initialize Hotjar tracking
  // useAutoHotjarTracking();
  
  return <AppRoutes />;
};
import ViewportProvider from '@/context/ViewPortProvider';

const AppContent: React.FC = () => {
  const { mode, colors } = useTheme();
  const { isInitialized } = useAppInit();
  const theme = createAppTheme(mode, colors);

  // Show loading screen while initializing authentication
  if (!isInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalLoader />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <GlobalLoader />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: mode === 'dark' ? COLORS.NEUTRAL.GREY_800 : COLORS.NEUTRAL.WHITE,
              color: mode === 'dark' ? COLORS.NEUTRAL.WHITE : COLORS.NEUTRAL.GREY_800,
            },
          }}
        />
        <Router>
          <AppRoutesWithTracking />
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ViewportProvider>
        <AppContent />
      </ViewportProvider>
    </Provider>
  );
};

export default App;
